module.exports = Em.Route.extend({})
